import { useTranslation } from 'react-i18next';
import { useActiveUploads } from '../context/UploadRegistryContext';

// Floating indicator showing total upload count and aggregate progress across all active uploads.
// Returns null when nothing is uploading — no DOM node, no visual flicker.
export function UploadProgressIndicator() {
  const { t } = useTranslation();
  const snapshot = useActiveUploads();

  const uploadingEntries = Array.from(snapshot.values()).filter((e) => e.status === 'uploading');
  if (uploadingEntries.length === 0) return null;

  const count = uploadingEntries.length;
  const aggregateProgress = Math.round(
    uploadingEntries.reduce((sum, e) => sum + e.progress, 0) / count
  );
  const label =
    count === 1
      ? uploadingEntries[0]!.fileName
      : t('documents.uploadProgress.multipleFiles', { count });

  return (
    <div className="fixed right-4 bottom-4 z-50 flex items-center gap-3 rounded-lg border border-border bg-surface px-4 py-2.5 shadow-lg">
      <div className="size-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      <div className="flex flex-col gap-1">
        <span className="max-w-[180px] truncate text-sm font-medium text-onsurface">{label}</span>
        <div className="h-1 w-40 overflow-hidden rounded-full bg-border">
          <div
            className="h-full rounded-full bg-primary transition-all duration-300"
            style={{ width: `${aggregateProgress}%` }}
          />
        </div>
      </div>
      <span className="text-xs tabular-nums text-onsurface/60">{aggregateProgress}%</span>
    </div>
  );
}
